import { EXERCISES_ENDPOINT, PROFILES_ENDPOINT } from '@gymaholic/packages'
import { ADDRESS_MODEL_CLASS_NAME } from 'models/daos/address/constants'
import { ARTICLE_MODEL_CLASS_NAME } from 'models/daos/article/constants'
import { CART_MODEL_CLASS_NAME } from 'models/daos/cart/constants'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { COMMENT_MODEL_CLASS_NAME } from 'models/daos/comment/constants'
import { EMAIL_TEMPLATE_MODEL_CLASS_NAME } from 'models/daos/email-template/constants'
import { LOG_MODEL_CLASS_NAME } from 'models/daos/log/constants'
import { MOTIVATION_MODEL_CLASS_NAME } from 'models/daos/motivation/constants'
import { NOTIFICATION_MODEL_CLASS_NAME } from 'models/daos/notification/constants'
import { ORDER_MODEL_CLASS_NAME } from 'models/daos/order/constants/index.cjs'
import { PAGE_MODEL_CLASS_NAME } from 'models/daos/page/constants'
import { PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { REPORT_MODEL_CLASS_NAME } from 'models/daos/report/constants'
import { SETTINGS_MODEL_CLASS_NAME } from 'models/daos/settings/constants'
import { TOKEN_MODEL_CLASS_NAME } from 'models/daos/token/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'
import { EXERCISE_CLASS_NAME } from 'modules/training/models/exercise/constants'
import { TRAINING_PROFILE_CLASS_NAME } from 'modules/training/models/profile/constants'

const MODEL_ENDPOINT = {
  AUTH: 'auth',
  ADDRESS: 'address',
  ARTICLES: 'articles',
  COMMENTS: 'comments',
  CART: 'cart',
  EMAIL_TEMPLATES: 'emailTemplates',
  HOME: '',
  LOGS: 'logs',
  MOTIVATION: 'motivation',
  NOTIFICATIONS: 'notifications',
  ORDERS: 'orders',
  PRODUCTS: 'products',
  PROMO_CODES: 'promoCodes',
  REPORTS: 'reports',
  SEARCH: 'search',
  SETTINGS: 'settings',
  TOKENS: 'tokens',
  PAGES: 'pages',
  USERS: 'users'
}

const MODEL_CLASS_NAME_TO_ENDPOINT = {
  [ADDRESS_MODEL_CLASS_NAME]: MODEL_ENDPOINT.ADDRESS,
  [ARTICLE_MODEL_CLASS_NAME]: MODEL_ENDPOINT.ARTICLES,
  [CATEGORY_MODEL_CLASS_NAME]: MODEL_ENDPOINT.HOME,
  [CART_MODEL_CLASS_NAME]: MODEL_ENDPOINT.CART,
  [COMMENT_MODEL_CLASS_NAME]: MODEL_ENDPOINT.COMMENTS,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: MODEL_ENDPOINT.EMAIL_TEMPLATES,
  [LOG_MODEL_CLASS_NAME]: MODEL_ENDPOINT.LOGS,
  [MOTIVATION_MODEL_CLASS_NAME]: MODEL_ENDPOINT.MOTIVATION,
  [NOTIFICATION_MODEL_CLASS_NAME]: MODEL_ENDPOINT.NOTIFICATIONS,
  [ORDER_MODEL_CLASS_NAME]: MODEL_ENDPOINT.ORDERS,
  [PAGE_MODEL_CLASS_NAME]: MODEL_ENDPOINT.PAGES,
  [PRODUCT_MODEL_CLASS_NAME]: MODEL_ENDPOINT.PRODUCTS,
  [PROMO_CODE_MODEL_CLASS_NAME]: MODEL_ENDPOINT.PROMO_CODES,
  [REPORT_MODEL_CLASS_NAME]: MODEL_ENDPOINT.REPORTS,
  [SETTINGS_MODEL_CLASS_NAME]: MODEL_ENDPOINT.SETTINGS,
  [TOKEN_MODEL_CLASS_NAME]: MODEL_ENDPOINT.TOKENS,
  [USER_MODEL_CLASS_NAME]: MODEL_ENDPOINT.USERS, // Training
  [EXERCISE_CLASS_NAME]: EXERCISES_ENDPOINT.EXERCISES,
  [TRAINING_PROFILE_CLASS_NAME]: PROFILES_ENDPOINT.PROFILES
}

/**
 * Get an api endpoint from the given className.
 * @param  {string} className
 * @returns {string}
 */
export default function getEndpointFromClassNameModelUtil (className) {
  return `/${MODEL_CLASS_NAME_TO_ENDPOINT[className]}`
}
